<template slot-scope="props">
  <div>
    <link-prevue :url="normalize(reference.url)" cardWidth='100%'>
      <template slot="loading">
        <!-- set your custom loading -->
        <div style="display:inline-block; margin:0px">
          <div class="w3-left" :style="`margin-left:10px`">
            <a :href="normalize(reference.url)" :target="'_newTab_'+reference.url">
              {{truncate(reference.url, 50)}}
            </a>
          </div>
          <div class="w3-left" style="margin-left:10px" v-if="reference.description">
            {{reference.description}}
          </div>
        </div>
      </template>
      <template slot-scope="props">
        <div style="display:inline-block; margin:0px">
          <div class="w3-left" v-if="props.img">
            <a :href="normalize(reference.url)" :target="'_newTab_'+props.title">
              <img class="card-img-top" :src="props.img" :alt="props.title" width="70px">
            </a>
          </div>
          <div class="w3-left" :style="`${reference.description?'max-width: 50%; ':''}margin-left:10px`">
            <a :href="normalize(reference.url)" :target="'_newTab_'+props.title">
              {{truncate((props.title ? props.title : reference.url) , 50)}}
            </a>
            <p v-if="props.description">
              {{truncate(props.description, 200)}}
            </p>
          </div>
          <div class="w3-left" style="max-width: 40%; margin-left:10px" v-if="reference.description">
            {{reference.description}}
          </div>
        </div>
      </template>
    </link-prevue>
  </div>
</template>

<script>
  import ReferencePreview from './ReferencePreview.ts';

  export default ReferencePreview
</script>
